'use strict';

var React = require('react');

var SvgBlockquoteMajor = function SvgBlockquoteMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5h-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.75a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-.5v-1a.25.25 0 0 1 .25-.25.75.75 0 0 0 0-1.5 1.75 1.75 0 0 0-1.75 1.75v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.75v-1a.25.25 0 0 1 .25-.25.75.75 0 0 0 0-1.5 1.75 1.75 0 0 0-1.75 1.75v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-.5Z"
  }));
};
SvgBlockquoteMajor.displayName = "BlockquoteMajor";

exports.SvgBlockquoteMajor = SvgBlockquoteMajor;
